import React, { Component } from 'react'
import Header from './components/header'
import Footer from './components/footer'
import { Link } from 'react-router-dom';
import PageTilte from './components/pageTilte';
import axios from 'axios';
import { constantApp } from '../../config/constant';


class Produces extends Component {
    constructor() {
        super();

        this.state = {
            data: [],
            isLoading: true,
            // isNetworkError: false

        };

        // const script = document.createElement("script");
        // script.src = "http://apafan.ir/assets/js/script.js";
        // document.body.appendChild(script);


    }


    componentDidMount = async () => {

        window.scrollTo(0, 0)
        let url = `${constantApp.SERVERIP}:${constantApp.PORT_APPACHE}/PHP/Produce/Select_Produce.php`;

        let data = await axios.post(url)
            .then(function (response) {

                return response.data;
            })
            .catch(function (error) {
                // this.setState({ isNetworkError: true })
            });


        if (data !== undefined && data.length > 0) { this.setState({ data, isLoading: false }) }




    }


    render() {

        return (
            <div className="page-wrapper" >
                <Header />

                <PageTilte title={'محصولات'} />

                {this.state.isLoading ? <section className="blog-grid-section section-padding">
                    <div className="container " style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyItems: 'center', justifyContent: 'center' }}>
                        <i className="fa fa-circle-o-notch fa-spin" style={{ fontSize: 24 }}></i>
                        <br />
                        <p >در حال بارگزاری اطلاعات</p>
                    </div>
                </section> :



                    <section className="section-padding services-grid-section">
                        <div className="container">
                            <div className="row">
                                <div className="col col-xs-12">
                                    <div className="services-grids services-grid-view">


                                        {this.state.data.map((item) => {
                                            return (
                                                <div className="grid" key={item.idProduce}>
                                                    <div className="inner mk-bg-img" >
                                                        <div className="details ">




                                                            <div className="info">

                                                                <img src={process.env.PUBLIC_URL + `assets/images/produces/img-${item.idProduce}.jpg`} alt='' role='presentation' className="bg-image" />


                                                                <Link to={{
                                                                    pathname: `produce/${item.idProduce}`,
                                                                    state: { id: item.idProduce }
                                                                }}>
                                                                    <h3><i className="icon-apafan2ap" style={{ fontSize: '1.73em' }}></i> {item.ProduceName}</h3>
                                                                </Link>
                                                                <p>{item.Brief}</p>
                                                                <Link to={{
                                                                    pathname: `produce/${item.idProduce}`,
                                                                    state: { id: item.idProduce }
                                                                }} className="more">دریافت جزئیات</Link>
                                                            </div>





                                                        </div>
                                                    </div>
                                                </div>

                                            )
                                        })}



                                    </div>
                                </div>
                            </div>


                        </div>
                    </section>}

                <Footer />

            </div>
        );
    }
};

export default Produces; 